<PaymentButton class="kr-payment-button" :class="dynamicClasses" :disabled="isDisabled" :style="styles" type="button" @click="btnClick"></PaymentButton>